// Values shared across pages, so the homepage and /tectonics never drift.

// The one "Book a call" destination. Every Book a call link on the site
// reads this value, so swapping the booking link is a one-line change.
export const BOOKING_URL = 'https://tally.so/r/9qv9aK';

// Delivery destinations open to everyone (the homepage's "Out to the
// platforms" list). Apple Music, SiriusXM and Pandora are conditional and
// must never be added here: they need their condition in the same sentence.
export const DELIVERY_PLATFORMS = [
  'Spotify',
  'Spotify Notable',
  'Amazon',
  'Deezer',
  'Tidal',
  'SoundCloud',
  'Audiomack',
  'YouTube',
  'Vevo',
];

export const HEAD_BITCH_QUOTE = {
  text: '"At Head Bitch Music, Cadence has become an essential part of our weekly workflow... We can\'t imagine going back to manually pitching all of our priority releases through each and every portal, form, and pitch grid for every dsp one at a time."',
  attribution: 'Head Bitch Music',
};

export const RELEASE_QUALIFIER = 'Built for teams putting out two or more releases a week.';
